




































































































import Vue from "vue";
import Footer from "../components/master/Footer.vue";
import ImageInput from "../components/common/imageinput.vue";
import UserAvatar from "../components/common/user-avatar.vue";
import AbpBase from "../lib/abpbase";
import { VueTelInput } from "vue-tel-input";
import PrivacyModal from "../components/legal-docs/privacy-modal.vue";
import TermsModal from "../components/legal-docs/terms-modal.vue";

const prefixCls = "wizard";

export default AbpBase.extend({
  components: {
    Footer,
    ImageInput,
    UserAvatar,
    VueTelInput,
    PrivacyModal,
    TermsModal,
  },
  data() {
    return {
      showPrivacy: false,
      showTerms: false,
      currentStep: "setup",
      confirmation: null,
      registrationModel: {
        id: 0,
        name: "",
        emailAddress: "",
        accountName: "",
        phoneNumber: "",
        logoImage: null,
      },
      bindPhoneProps: {
        mode: "international",
        defaultCountry: "US",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Mobile Phone (for two-factor authentication)",
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: ["US"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
      saving: false,
      rules: {
        accountName: [
          {
            required: true,
            message: "Please fill in your account name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 30,
            message: "Max 30 characters.",
            trigger: "change",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: "Please fill in your mobile phone number",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    goToHomePage() {
      this.$store.dispatch("session/setCurrentBillingAccountId", this.confirmation.accountId).then(() => {
        location.replace(window.location.origin + abp.appPath);
        debugger;
        //location.reload();
      });
    },
    validatePhoneNumber() {
      let field = this.$refs.PhoneNumberField as any;
      field.validate("");
    },
    async updateProfile() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      (this.$refs.accountForm as any).validate(async (valid: boolean) => {
        if (valid) {
          this.currentStep = "loading";

          let requestData = {
            billingAccountName: this.registrationModel.accountName,
            phoneNumber: this.registrationModel.phoneNumber,
            logoImage: null,
          };

          context.$store
            .dispatch("account/createBillingAccount", requestData)
            .then((response) => {
              if (response.data.result.success === true) {
                this.confirmation = response.data.result;
                this.currentStep = "confirmation";
              } else {
                this.currentStep = "setup";
              }
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
